import { Component, Input } from '@angular/core';

import { Course } from '../../courses/shared/course';

@Component({
  selector: 'app-lecture-add-button-menu',
  templateUrl: 'lecture-add-button-menu.component.html'
})
export class LectureAddButtonMenuComponent {
  @Input() course: Course;
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-add-button-menu/lecture-add-button-menu.component.ts